import React, { useState, useEffect } from 'react';
import { Input, DatePicker } from 'antd';
import columns from '../../../columns/ib/Commission.js';
import TableWithSkeleton from '../../../components/table/TableWithSkeleton.jsx';
import Pagination from '../../../components/pagination/Pagination.jsx';
import { presets } from '../../../utils/RangePickerPresets.js';
import moment from 'moment/moment.js';
import { GetCommissionApi, GetCommissionlotApi } from '../../../api/request/ib/commission.js';
import { useSearchParams } from "react-router-dom";
import dayjs from 'dayjs';
import ExportHandler from '../../../components/global/export/ExportHandler.jsx';
const { RangePicker } = DatePicker;

export default function Commission() {

    const [searchParams, setSearchParams] = useSearchParams();
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecord, setTotalRecord] = useState(0);
    const [search, setSearch] = useState('');
    const [searchText, setSearchText] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isExportLoading, setIsExportLoading] = useState(false);
    const [data, setData] = useState([]);
    const [lotData, setDatalot] = useState({})
    const [overviewRange, setOverviewRange] = useState({ from: '', to: '' });
    
    let currentDate = moment(new Date()).format('YYYY/MM/DD');

    const getCommission = async () => {
        try {
            setIsLoading(true);
            let params = {
                PageNumber: page,
                PageSize: pageSize,
                SearchText: searchText.trim(),
                FromDate: overviewRange?.from,
                ToDate: overviewRange?.to,
            }
            const { data } = await GetCommissionApi(new URLSearchParams(params).toString());
            if (data?.success) {
                setData(data?.data?.map((item) => {
                    return ({
                        ...item,
                        name: `${item?.firstName} ${item?.lastName}`,
                        registeredDate: item?.deal_Date ? moment(item?.deal_Date).format('DD-MM-YYYY LT') : null,
                        ibCommDate: item?.ibCommDate ? moment(item?.ibCommDate).format('DD-MM-YYYY LT') : null,
                        ibCommission: `$ ${item?.ibCommission}`,
                    })
                }))
                setTotalRecord(data?.totalRecords);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    }

    const getCommissionlot = async () => {
        try {
            setIsLoading(true);
            let params = {
                FromDate: overviewRange?.from,
                ToDate: overviewRange?.to,
            }
            const { data } = await GetCommissionlotApi(new URLSearchParams(params).toString());
            if (data?.success) {
                setDatalot(data?.data)
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getCommissionlot();
        getCommission();
    }, [page, pageSize,searchText, overviewRange]);

    useEffect(() => {
        if (searchParams?.get("filter")?.trim() == 'today') {
            let currentDate = moment(new Date()).format('MM/DD/YYYY');
            setOverviewRange({ from: currentDate, to: currentDate });
        }
    }, []);

    const exportHandler = async () => {
        try {
            setIsExportLoading(true);
            let params = {
                ApplyPagination: false,
                SearchText: searchText,
                FromDate: overviewRange?.from,
                ToDate: overviewRange?.to,
            };
            const { data } = await GetCommissionApi(new URLSearchParams(params).toString());
            if (data?.success) {
                return { data: data?.data, removableColumns: ['userId'], fileName: 'Commission' };
            } else {
                return { data: [], removableColumns: [] };
            }
        } catch (error) {
            return { data: [], removableColumns: [] };
        }
    };

    const handleDateChange = (value, type) => {
        if (value && value.length === 2) {
            const fromDate = value[0].format('MM/DD/YYYY');
            const toDate = value[1].format('MM/DD/YYYY');
            if (type == 'Commission') {
                setOverviewRange({ from: fromDate, to: toDate });
            }

        }
        if (!value || value.length === 0) {
            if (type == 'Commission') {
                setOverviewRange({ from: '', to: '' });
            }
        }
    };

    const disabled7DaysDate = (current, { from }) => {
        if (from) {
            return Math.abs(current.diff(from, 'days')) >= 7;
        }
        return false;
    };
    useEffect(() => {
        setPage(1);
      }, [searchText]);

    return (
        <div>
            <div className="flex justify-between flex-wrap gap-5">
                <div className='ant-date-range-selector-white'>
                    <RangePicker className='border-primary my-[2px] py-2' disabledDate={disabled7DaysDate} onChange={(value) => handleDateChange(value, 'Commission')} presets={presets} defaultValue={searchParams?.get("filter")?.trim() == 'today' ? [dayjs(currentDate, 'YYYY/MM/DD'), dayjs(currentDate, 'YYYY/MM/DD')] : null} format='DD-MM-YYYY' />
                </div>
                <div className="flex items-center">
                    <div className="mr-3">
                        <Input
                            size="large"
                            style={{ width: 220 }}
                            placeholder="Search"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            onPressEnter={() => setSearchText(search)}
                            prefix={
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                    class="w-5 h-5"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z"
                                        clip-rule="evenodd"
                                    />
                                </svg>
                            }
                            suffix={
                                search && (
                                    <svg xmlns="http://www.w3.org/2000/svg" onClick={() => { setSearchText(""); setSearch(""); }}
                                        viewBox="0 0 24 24" fill="#bebebe" className="size-5 cursor-pointer duration-300 hover:fill-[#969595]">
                                        <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z" clip-rule="evenodd" />
                                    </svg>
                                )
                            }
                        />
                    </div>
                    <div >
                        <ExportHandler exportHandler={exportHandler} />
                    </div>
                </div>
            </div>
            <div className="w-full mt-3">
                <div className="px-2 lg:px-4 flex flex-wrap items-center mb-3">
                    <p className="text-[#2F2B3D] text-xl font-semibold mr-2">IB Commission</p>
                    (<div className="my-2 flex items-center">
                        <p className="text-[#1E232CC7] sm:text-lg text-sm">Lot:-</p>
                        <p className="primary sm:text-lg text-sm font-semibold "> {lotData?.totalLot || 0}</p>
                    </div>
                    <div className="my-2 flex items-center sm:ml-2">
                        <p className="text-[#1E232CC7] sm:text-lg text-sm">Commission:-</p>
                        <p className="primary sm:text-lg text-sm font-semibold"> $ {lotData?.totalCommission || 0}</p>
                    </div>)
                </div>
                <div>
                  <div className="border border-gray-200 rounded-xl">
                    <TableWithSkeleton columns={columns} data={data} loading={isLoading} />
                  </div>
                    <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
                </div>
            </div>
        </div>
    )
}